<template>
    <!-- 新手指导 -->
    <div class="container">
        <!-- <p>新</p> -->
        <Title-b :title="$t('Side.Noviceguidance')" />
        <div class="hr"></div>
        <div class="one">
            <h1>一、註冊會員帳號</h1>
            <p @click="dj()">首先：點擊鏈接進入集運VIP會員中心：<span style="display:inline-block;color:red">https://member.shengdaexp.com</span></p>
            <br>
            <Title-b title="步驟1：點擊【立即註冊】：" />
            <br>
            <img src="@/assets/images/sjOne.jpg" alt="" style="width:100%">
            <br>
            <Title-b title="步驟2：填寫會員信息" />
            <br>
            <img src="@/assets/images/sjTwo.jpg" alt="" style="width:100%">
            <br>
            <p><span class="p">會員用戶名(必填)：</span>用戶名建議輸入便於您牢記的任何數字或者手機號碼作為登錄用戶名；</p>
            <p><span class="p">密碼設定 (必填)：</span>設置您的登錄密碼（至少6位數 要牢記），再次輸入密碼並確認；</p>
            <p><span class="p">電子郵箱 (必填)：</span>填寫有效的電子郵箱，便於接收快遞入庫、包裹物流軌跡、優惠活動等信息；</p>
            <p><span class="p">手機號碼 (選填)：</span>選填項，可不填寫</p>
            <p><span class="p">推薦人編號 (選填)：</span>選填項，如有推薦人時填寫推薦人的ID編碼，如沒有推薦人則不用填寫；</p>
            <br>
            <Title-b title="步驟3：" />
            <p>認真閱讀《承运条款》條款後，勾選 我已同意集运《承运条款》；最後，點擊【立即註冊】按鈕 即可註冊成功；</p>
            <br>
            
            <h1>二、登錄會員中心</h1>
            <img src="@/assets/images/sjThree.png" alt="" style="width:100%">
            <br>
            <Title-b title="步驟1：" style="display: inline-block;" /><span>輸入您註冊時填寫的會員用戶名或者ID編碼（ID編碼首次註冊要進入會員中心後才可以看到）；</span><br>
            <Title-b title="步驟2：" style="display: inline-block;" /><span>輸入您註冊時填寫的會員登錄密碼；</span><br>
            <Title-b title="步驟3："  style="display: inline-block;" /><span>根據右邊框中出現的數字按順序輸入驗證碼；</span><br>
            <Title-b title="步驟4：" style="display: inline-block;" /><span>最後點擊【登錄】即可進入到會員中心；</span><br>
            <br>
            <h1>三、獲取集運倉庫地址</h1>
            <Title-b title="步驟1：登錄會員中心---在會員中心頁面最下方找到【倉庫地址 深圳倉】點“復制”獲取您的專屬集運倉庫地址；" />
            <img src="@/assets/imgs/si.png" alt="">
            <Title-b title="步驟2：將您復制的“倉庫地址”在您購物的電商平臺上添加為收貨地址，或直接提供給發貨方將貨物發往集運倉庫。" />
            <!-- <p>如下圖，以淘寶平臺購物為例：</p>
            <img src="@/assets/imgs/wu.png" alt=""> -->
            <br>

            <h1>四、預報包裹</h1>
            <Title-b title="步驟1：會員中心在快速通道找到“預報包裹”；" />
            <img src="@/assets/imgs/liu.png" alt="">
            <br>
            <Title-b title="步驟2：在您購物的電商平臺上，將賣家發貨後的物流快遞單號進行複製" />
            <p>如下圖，以淘寶平臺購物為例：</p>
            <img src="@/assets/imgs/qi.png" alt="">
            <br>
            <Title-b title="步驟3：將您複製的快遞單號、集運的貨物品名、類型以及數量，在預報包裹界面正確填寫。" />
            <p>如下圖1，單個包裏預報示例：</p>
            <img src="@/assets/imgs/ba.png" alt="">
            <p>如下圖2，包裹批量預報示例：</p>
            <img src="@/assets/imgs/jiu.png" alt="">
            <p><span class="p">快遞單號：</span>指您在電商平臺購物，賣家發貨後顯示的快遞物流單號；</p>
            <p><span class="p">貨物品名：</span>指您所要集運的貨物名稱（必須要如實填寫、預報），虛報填寫後果自負，如不確定是否可集運的貨物可諮詢客服哦；</p>
            <p><span class="p">貨物類型：</span>普貨、特貨、防疫特貨；</p>
            <p><span class="p">物品數量：</span>指快遞包裹物品數量；</p>
            <p><span class="p">備註說明（選填）：</span>特殊物品需備註說明，並告知客服；</p>
            <p>最後，確認預報包裹信息點<span class="p">【提交】</span>即可預報成功。</p>
            <br>


            <h1>五、添加收貨地址</h1>
            <Title-b title="步驟1：會員中心點擊“地址管理” " />
            <img src="@/assets/imgs/shi.png" alt="">
            <br>
            <Title-b title="步驟2：點擊“ 添加收貨地址”， 根據提示正確填寫收貨地址信息並保存。 " />
            <img src="@/assets/imgs/shiyi.png" alt="">
            <br>
            <p>提示：新添加的收貨地址需集運審核後方能使用，建議您提前添加。</p>
            <img src="@/assets/imgs/shier.png" alt="">
            <br>


            <h1>六、申請集運</h1>
            <p>申請集運需顯示在“已入庫”狀態後方可操作，如顯示“待入庫”狀態暫時不可以申請集運</p>
            <Title-b title="步驟1.：會員中心，點擊“申請集運” " />
            <img src="@/assets/imgs/shisan.png" alt="">
            <br>
            <Title-b title="步驟2：進入“已入庫”界面後,根據您的實際需求可一次性申請全部貨物集運或者選擇單件貨物集運，選擇完成後點擊“申請集運。” " />
            <img src="@/assets/imgs/shisi.png" alt="">
            <br>
            <Title-b title="步驟3：確認集運包裹信息，根據您的需求正確選擇收貨地址 。 " />
            <img src="@/assets/imgs/shiwu.png" alt="">
            <br>
            <Title-b title="步驟4：付款方式選擇" />
            <p>集運付款方式支持余額支付、淘寶店支付、微信支付、支付寶支付。微信支付隻限大陸版。確認集運貨物信息，根據您的<br>實際情況選擇適合您的支付方式，最後點“申請集運”；</p>
            <img src="@/assets/imgs/shiliu.png" alt="">
            <br>
            <p class="p">關於淘寶店支付：</p>
            <p>淘寶店支付需要到集運的專屬店鋪去支付運費，選擇對應的運費鏈接支付（運費總金額=數量，根據實際運費總金額<br>輸入相等的數量），在提交訂單頁必須在賣家留言處備註ID編碼或者支付碼。</p>
            <p><span>1：</span>點擊<span class="p">“複製”</span>支付碼；</p>
            <img src="@/assets/imgs/shiqi.png" alt="">
            
            <p><span>2：</span>點擊鏈接進入到的專屬淘寶店後，選擇對應的鏈接（比如總運費金額為45.1元：那麼先找到1.1的鏈接，在1元的選<br>項輸入<span style="color:red">44</span>，在1.1元的選項輸入<span style="color:red;">1 </span> ；
如下圖：</p>
            <img src="@/assets/imgs/ershi.png" alt="">
            <p><span>3：</span>點擊結算後，在賣家留言處粘貼您剛複製的支付碼或者ID編碼；</p>
            <img src="@/assets/imgs/shiba.png" alt="">
            <p>最後點擊<span>“提交訂單”</span>，付款成功。</p>
            <br>


            <h1>七、等待收貨</h1>
            <p>申請集運付款成功後，可在我的訂單界面實時查看訂單狀態。</p>
            <img src="@/assets/imgs/shijiu.png" alt="">
            <p>集運：香港：時效2-3個工作日，泰国：时效5-7个工作日，台湾空运：3-4个工作日，海运：5-7个工作日，越南陆运：4-6个工作日特殊情況：
當遇上天氣惡劣/海關查處/雨天/公眾假期/偏遠地區/6.18/雙11/雙12等情況，為了保證貨物安全，貨物可能會延遲派送，
特殊情況請留意集運官網公告。</p>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        dj(){
            this.$router.push('./register');
        }
    }
}
</script>
<style lang="scss" scoped>
    .container{
        width: 1069px;
        border-radius: 5px;
        background: #fff;
        padding: 19px 17px;
        /deep/ .unify-title{
            font-weight: bold;
            font-size: 18px;
            height: 18px;
            margin: 10px 0;
        }
        .hr{
            margin: 15px 0 0 0;
            width: 1000px;
            height: 1px;
            border-bottom: 1px solid #cccccc;
        }
        .one{
            margin: 10px 0 0 0;
            h1{
                font-weight: bold;
                color: #000;
            }
            .p{
                font-weight: bold;
            }
            p{
                margin: 5px 0;
                font-size: 18px;
                cursor: pointer;
                color: #000;
            }
            img{
                margin: 10px 0px;
            }
            span{
                // display: inherit;
                font-size: 16px;
                color: #000;
                cursor: pointer;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/view/memberservices/Noviceguidance.vue